import { render, staticRenderFns } from "./CulturePromotionContentPostAudit.vue?vue&type=template&id=28249556&scoped=true&"
import script from "./CulturePromotionContentPostAudit.vue?vue&type=script&lang=js&"
export * from "./CulturePromotionContentPostAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28249556",
  null
  
)

export default component.exports